var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMan1ArmShaking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "33px",
    viewBox: "0 0 36 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Man1ArmShaking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man1ArmShaking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5454232,9.64952575 L22.5464265,9.65158676 C23.7203,11.8403844 26.4262289,12.6452107 28.5572608,11.4395171 L33.7122711,8.52421168 C35.8443063,7.31851804 36.6278919,4.54027014 35.4550217,2.35044194 L35.4540184,2.34941144 C34.2801449,0.159583247 31.5752193,-0.64524302 29.4431841,0.560450619 L24.2881738,3.47575601 C22.1561386,4.68144965 21.3715497,7.45969755 22.5454232,9.64952575",
    id: "Fill-105",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,11.7439617 C28,11.7439617 14.8104889,29.218258 9.29570713,32.4267568 C3.77990848,35.6352555 0,24.3286478 0,24.3286478 L21.8435389,6 L28,11.7439617",
    id: "Fill-106",
    fill: "#34C8CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan1ArmShaking);
export default __webpack_public_path__ + "static/media/Man1ArmShaking.87e1cae3fa2f69854d32bc25f8cb1b7d.svg";
export { ForwardRef as ReactComponent };